<template>
  <!-- <div v-for="{ user, message } of formattedChat" :key="hash({ user, message })" class="my-4"> -->
  <div class="my-4">
    <v-card class="msg">
      <v-btn
        class="expand-btn"
        :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        @click="show = !show" variant="text" size="x-large"
      ></v-btn>
      <v-expand-transition>
        <v-card-title v-if="!show"  @click="show = !show" class="clickable d-block mr-8 mb-n4">
          Full Analysis
        </v-card-title>
      </v-expand-transition>
      <v-card-text>
        <v-expand-transition>
          <div v-if="show">
            <div v-if="msgFormatted !== ''">
              <pre ref="pre"><code class="chat-text language-markdown" v-html="msgFormatted"></code></pre>
              <v-expansion-panels class="mt-4">
                <v-expansion-panel title="Income Statements" @click="incomeStatementClicked">
                  <v-expansion-panel-text>
                    <Code v-if="incomeStatementSummary !== ''" :msg="incomeStatementSummary" />
                    <p v-else class="text-caption">Fetching income statement summary...</p>
                  </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel title="Cashflow Statements" @click="cashflowStatementClicked">
                  <v-expansion-panel-text>
                    <Code v-if="cashflowStatementSummary !== ''" :msg="cashflowStatementSummary" />
                    <p v-else class="text-caption">Fetching cashflow statement summary...</p>
                  </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel title="Balance Sheets" @click="balanceSheetClicked">
                  <v-expansion-panel-text>
                    <Code v-if="balanceSheetSummary !== ''" :msg="balanceSheetSummary" />
                    <p v-else class="text-caption">Fetching balance sheet summary...</p>
                  </v-expansion-panel-text>
                </v-expansion-panel>
                <v-expansion-panel title="News" @click="newsClicked">
                  <v-expansion-panel-text>
                    <div v-if="allNews != null">
                      <h4 class="text-h4 mb-4">News Summary/Highlights</h4>
                      <Code :msg="allNews.newsSummary.summary" />
                      <ul>
                        <li v-for="link in allNews.newsSummary.links" :key="link">
                          <a :href="link" target="_blank">{{ link }}</a>
                        </li>
                      </ul>
                    </div>
                    <p v-else class="text-caption">Fetching news summary...</p>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <div v-else class="chat-bubble">
              <div class="typing">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>
            </div>
          </div>
        </v-expand-transition>
      </v-card-text>
    </v-card>
  </div>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { marked } from 'marked'
import Prism from 'prismjs'
import 'prismjs/themes/prism-okaidia.css'
import { mapState } from 'vuex'
import { hash } from '@/utils/general'
import { AllNews } from '@/utils/api'
import Code from './Code.vue'

@Options({
  props: {
    id: String,
    msg: String,
    timestamp: Number,
    symbol: String
  },
  computed: {
    ...mapState([]),
  },
  components: {
    Code
  }
})
export default class AnalysisExpanded extends Vue {
  id!: string
  msg!: string
  msgHash: string = ''
  msgFormatted: string = ''

  incomeStatementSummary = ''
  cashflowStatementSummary = ''
  balanceSheetSummary = ''
  allNews: AllNews | null = null
  newsSummary = ''

  timestamp!: number
  symbol!: string

  show = false

  async mounted() {
    await this.updateMessages()
  }

  async updated() {
    await this.updateMessages()
  }

  async updateMessages() {
    const agentMsgHash = hash(this.msg)
    if ((this.msg != null && this.msg !== '') && (agentMsgHash !== this.msgHash)) {
      this.msgFormatted = await this.formatMarkdown(this.msg)
      this.msgHash = agentMsgHash
      console.log('Messages updated')
    }
  }

  async formatMarkdown(text: string): Promise<string> {
    return marked.parse(text)
  }

  async incomeStatementClicked() {
    if (this.incomeStatementSummary === '') {
      console.log({ id: this.id, symbol: this.symbol, timestamp: this.timestamp })
      const summary: string | undefined = await this.$store.dispatch('getIncomeStatementSummary', { id: this.id, symbol: this.symbol, timestamp: this.timestamp })
      if (summary != null) {
        this.incomeStatementSummary = summary
      } else {
        this.incomeStatementSummary = 'No income statement data available'
      }
    }
  }

  async cashflowStatementClicked() {
    if (this.cashflowStatementSummary === '') {
      const summary: string | undefined = await this.$store.dispatch('getCashFlowStatementSummary', { id: this.id, symbol: this.symbol, timestamp: this.timestamp })
      if (summary != null) {
        this.cashflowStatementSummary = summary
      } else {
        this.cashflowStatementSummary = 'No cashflow statement data available'
      }
    }
  }

  async balanceSheetClicked() {
    if (this.balanceSheetSummary === '') {
      const summary: string | undefined = await this.$store.dispatch('getBalanceSheetSummary', { id: this.id, symbol: this.symbol, timestamp: this.timestamp })
      if (summary != null) {
        this.balanceSheetSummary = summary
      } else {
        this.balanceSheetSummary = 'No balance sheet data available'
      }
    }
  }

  async newsClicked() {
    if (this.allNews == null) {
      const news: AllNews | undefined = await this.$store.dispatch('getAllNews', { id: this.id, symbol: this.symbol }) as AllNews
      if (news != null) {
        this.allNews = news
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .clickable {
    cursor: pointer;
  }
  .expand-btn {
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px;
  }
  .chat-bubble {
    // background: #e6e6e6;
    // top: -30px;
    margin-left: -20px;
    border-radius: 15px;
    padding: 15px 25px;
    display: inline-block;
    position: relative;

    .typing {
      display: flex;
      gap: 4px;
      align-items: center;
      height: 17px;
    }

    .dot {
      width: 7px;
      height: 7px;
      background: #757575;
      border-radius: 50%;
      animation: bounce 1.8s linear infinite;
    }

    .dot:nth-child(2) {
      animation-delay: 0.3s;
    }

    .dot:nth-child(3) {
      animation-delay: 0.6s;
    }
  }

  @keyframes bounce {
    0%, 40%, 100% {
      transform: translateY(0);
    }
    20% {
      transform: translateY(-8px);
    }
  }

  .msg {
    border: 1px solid rgb(133, 133, 133);
    border-radius: 8px;
    padding: 20px;
  }

  code[class*="language-"] > ul,
  code[class*="language-"] > ol {
    padding-left: 40px !important;
  }

  pre[class*="language-" ],
  code[class*="language-"] {
    background: #02131f;
    box-sizing: border-box;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 18px;
    overflow: auto;
    white-space: normal;
    word-break: break-word;

    ol {
      margin-left: 40px;
    }
    ul {
      margin-left: 40px;
    }
    dl {
      margin-left: 40px;
    }

    &:deep(ul, ol, dl) {
      padding-left: 40px;
      // padding-left: 1rem;
      list-style-position: outside;
    }
  }
</style>